import { Component, OnInit, ViewChild } from '@angular/core';
import { AdminServiceService } from 'src/app/services/admin/admin-service.service';
import { Router } from '@angular/router';
import {AccountDetailService} from '../../../services/account/account-detail.service';
import { AccountService } from 'src/app/services/account/account.service';
import { Evaluation } from 'src/app/models/evaluation/evaluation';
import * as $ from 'jquery';
import {NotificationService} from 'src/app/services/notification/notification.service';
import {generateId} from 'src/app/models/notification/notification';

@Component({
  selector: 'app-vendor-list',
  templateUrl: './vendor-list.component.html',
  styleUrls: ['./vendor-list.component.scss'],
})
export class VendorListComponent implements OnInit {
  @ViewChild('closeButton') public closeButton;
  vendorList = [];
  vendorToDelete;
  searchValue: string;
  searchSelect: string;
  counterActive: number = 0;
  counterPending: number = 0;
  counterDemo: number = 0;
  evaluation: Evaluation = new Evaluation();
  disableSaveButton: boolean = false;
  constructor(
    private accountDetailService: AccountDetailService,
    private adminService: AdminServiceService,
    private accountService: AccountService,
    private router: Router,
    public notificationService: NotificationService
  ) {}

  ngOnInit(): void {
    this.getVendorList(0);
    this.searchValue = '';
    this.searchSelect = '';
  }

  getVendorList(page: number) {
    this.adminService.getVedorList(page).subscribe((data) => {
      this.vendorList = data;
      data.forEach(element => {
        switch(element.type) {
          case 'active': this.counterActive++; break;
          case 'pending': this.counterPending++; break;
          case 'demo': this.counterDemo++; break;
          default: {}
        }
      });
    });
  }

  impersonate(account: string) {
    this.cleanPermissions();

    if (!localStorage.getItem('OriginalAccount'))
      localStorage.setItem('OriginalAccount', localStorage.getItem('HechRomeoAccount'));
    else if (account == localStorage.getItem('OriginalAccount'))
      localStorage.removeItem('OriginalAccount');

    localStorage.setItem('HechRomeoAccount', account);
    this.accountDetailService.setAccount(account);
    this.router.navigate(['categoriesAndServices'], {state: {switched: true}});
  }

  deleteVendor(username: string) {
    this.adminService.deleteVendor(username).subscribe(() => {
      this.getVendorList(0);
    });
  }

  infoVendor(username: string) {
    this.cleanPermissions();
    localStorage.setItem('HechRomeoAccount', username);
    this.accountDetailService.setAccount(username);
    this.router.navigate(['accountInfo'], {state: {switched: true}});
  }

  cleanPermissions() {
    localStorage.removeItem('categoriesServices');
    localStorage.removeItem('digitalSignage');
    localStorage.removeItem('guestsManagement');
    localStorage.removeItem('tvManagement');
    localStorage.removeItem('integrations');
    localStorage.removeItem('HechRomeoVendor');
  }

  changeVendorType(vendorToEdit, type) {

    vendorToEdit.type = type;
    this.counterActive = 0, this.counterPending = 0, this.counterDemo = 0;
    this.vendorList.forEach(element => {
      switch(element.type) {
        case 'active': this.counterActive++; break;
        case 'pending': this.counterPending++; break;
        case 'demo': this.counterDemo++; break;
        default: {}
      }
    });

    let vendorType = {
      account: vendorToEdit.account,
      type: type,
    };

    this.accountService.changeVendorType(vendorType).subscribe(() => {
    });
  }

  // Trying to fix a bug in the Tiny editor, with not much success sadly
  onInitEditor(): void {
    $('button[title="Align left"]').trigger('click');
  }
  // Modification or creation of a category interrupted by the user
  cancelEditEvaluation() {
    this.evaluation = new Evaluation();
  }
  // Saves a root category
  async saveEvaluation() {
    this.disableSaveButton = true;

    let data = {
      account: this.evaluation.account,
      rate: this.evaluation.rate.toString(),
      date: this.evaluation.date,
      description: encodeURI(this.evaluation.description)
    }

    this.accountService.updateEvaluation(data).subscribe(() => {
      const notification = {
        id: generateId(),
        image: undefined,
        title: 'Riuscito',
        body: 'Inserimento Valutazione',
      };

      this.notificationService.addNotification(notification);

      this.closeButton.nativeElement.click();

      this.getVendorList(0);
    });
  }

  checkEvaluationRate() {
    if (this.evaluation.rate > 10)
      this.evaluation.rate = 10;
  }

  setAccountEvaluationData(vendor) {
    this.evaluation.account = vendor.account;
    if (vendor.evalrate) this.evaluation.rate = vendor.evalrate;
    if (vendor.evaldate) this.evaluation.date = vendor.evaldate;
    if (vendor.evaldesc) this.evaluation.description = decodeURI(vendor.evaldesc);
  }
}
